export const DecryptAES = (encryptedValue, aesKey, aesIV) => {
    var aesjs = require('aes-js');
    var base64js = require('base64-js')

    if (encryptedValue.length > 0) {
        // convert key string to bytes...
        var key = base64js.toByteArray(aesKey)
        // convert iv string to bytes...
        var iv = base64js.toByteArray(aesIV)
        var encryptedBytes = base64js.toByteArray(encryptedValue);
        var aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
        var decryptedBytes = aesjs.padding.pkcs7.strip(aesCbc.decrypt(encryptedBytes));
        var decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);

        return decryptedText
    }
    else {
        return null
    }
}

export const EncryptAES = (clearText, aesKey, aesIV) => {
    var aesjs = require('aes-js');
    var base64js = require('base64-js')

    if (clearText.length > 0) {
        // convert key string to bytes...
        var key = base64js.toByteArray(aesKey)
        // convert iv string to bytes...
        var iv = base64js.toByteArray(aesIV)
        // convert clear string to bytes...           
        var textBytes = aesjs.padding.pkcs7.pad(aesjs.utils.utf8.toBytes(clearText));

        var aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
        var encryptedBytes = aesCbc.encrypt(textBytes);

        // To print or store the binary data, you may convert it to hex
        var encrypted = base64js.fromByteArray(encryptedBytes);

        return encrypted
    }
    else {
        return null;
    }
}